import { createQueryParams } from "types/content_generation";
import { ApiClient } from "client/base";
const rt_ais_connections = "ai_service_connections";
const rt_ais_models = "ai_service_models";
const rt_cg_collections = "content_generation_collections";
const rt_cg_example_sets = "content_generation_example_sets";
const rt_cg_executions = "content_generation_executions";
const rt_cg_results = "content_generation_results";
const rt_ft_executions = "fine_tuning_executions";
export class ContentGenerationClient extends ApiClient {
    getConnectionById(connectionId) {
        return this.base.get(`${rt_ais_connections}/${connectionId}`);
    }
    deleteConnection(connectionId) {
        return this.base.delete(`${rt_ais_connections}/${connectionId}`);
    }
    updateConnection(connectionId, post) {
        return this.base.patch(`${rt_ais_connections}/${connectionId}`, post);
    }
    getConnections(query) {
        const params = createQueryParams(query);
        return this.base.get(`${rt_ais_connections}?${params}`);
    }
    createConnection(post) {
        return this.base.post(rt_ais_connections, post);
    }
    reloadModels() {
        return this.base.get(`${rt_ais_models}/reload`);
    }
    createModel(connectionId, post) {
        return this.base.post(`${rt_ais_connections}/${connectionId}/models`, post);
    }
    getModelById(modelId) {
        return this.base.get(`${rt_ais_models}/${modelId}`);
    }
    deleteModel(modelId) {
        return this.base.delete(`${rt_ais_models}/${modelId}`);
    }
    updateModel(modelId, post) {
        return this.base.patch(`${rt_ais_models}/${modelId}`, post);
    }
    getModels(query) {
        const params = createQueryParams(query);
        return this.base.get(`${rt_ais_models}?${params}`);
    }
    getConnectionModels(connectionId) {
        return this.base.get(`${rt_ais_connections}/${connectionId}/models`);
    }
    getCollectionById(collectionId) {
        return this.base.get(`${rt_cg_collections}/${collectionId}`);
    }
    deleteCollection(collectionId) {
        return this.base.delete(`${rt_cg_collections}/${collectionId}`);
    }
    updateCollection(collectionId, post) {
        return this.base.patch(`${rt_cg_collections}/${collectionId}`, post);
    }
    getCollections(query) {
        const params = createQueryParams(query);
        return this.base.get(`${rt_cg_collections}?${params}`);
    }
    getCollectionComments(collectionId) {
        return this.base.get(`${rt_cg_collections}/${collectionId}/comments`);
    }
    addCollectionComments(collectionId, post) {
        return this.base.post(`${rt_cg_collections}/${collectionId}/comments`, post);
    }
    getCollectionRatings(collectionId) {
        return this.base.get(`${rt_cg_collections}/${collectionId}/ratings`);
    }
    addCollectionRating(collectionId, post) {
        return this.base.post(`${rt_cg_collections}/${collectionId}/ratings`, post);
    }
    createCollection(post) {
        return this.base.post(rt_cg_collections, post);
    }
    createExecution(post) {
        return this.base.post(rt_cg_executions, post);
    }
    getExampleSetById(exampleSetId) {
        return this.base.get(`${rt_cg_example_sets}/${exampleSetId}`);
    }
    getExampleSetResultView(exampleSetId) {
        return this.base.get(`${rt_cg_example_sets}/${exampleSetId}/results`);
    }
    deleteExampleSet(exampleSetId) {
        return this.base.delete(`${rt_cg_example_sets}/${exampleSetId}`);
    }
    removeExampleSetResultLink(exampleSetId, resultId) {
        return this.base.delete(`${rt_cg_example_sets}/${exampleSetId}/results/${resultId}`);
    }
    updateExampleSet(exampleSetId, post) {
        return this.base.patch(`${rt_cg_example_sets}/${exampleSetId}`, post);
    }
    addExampleSetResultLink(exampleSetId, resultId) {
        return this.base.post(`${rt_cg_example_sets}/${exampleSetId}/results/${resultId}`);
    }
    addExampleSetSyntheticData(exampleSetId, synthDataCount) {
        // This is the payload for synthetic dataset
        console.log("-=-=-=-=-=-=- adding", exampleSetId, synthDataCount);
        const payload = {
            example_set_id: exampleSetId,
            synthetic_data_count: synthDataCount,
            type: "DATA_GENERATION"
        };
        return this.base.post(`${rt_ft_executions}`, payload).then((r) => {
            console.log("-=-=-=-=- add data return", r);
            return this.base.get(`${rt_cg_example_sets}/${exampleSetId}`);
        });
    }
    getExampleSets(query) {
        const params = createQueryParams(query);
        return this.base.get(`${rt_cg_example_sets}?${params}`);
    }
    createExampleSet(post) {
        return this.base.post(rt_cg_example_sets, post);
    }
    addExecutionToExampleSet(exampleSetId, resultId) {
        return this.base.post(`${rt_cg_example_sets}/${exampleSetId}/results/${resultId}`);
    }
    getExecutionById(executionId) {
        return this.base.get(`${rt_cg_executions}/${executionId}`);
    }
    deleteExecution(executionId) {
        return this.base.delete(`${rt_cg_executions}/${executionId}`);
    }
    updateExecution(executionId, post) {
        return this.base.patch(`${rt_cg_executions}/${executionId}`, post);
    }
    getExecutions(query) {
        const params = createQueryParams(query);
        return this.base.get(`${rt_cg_executions}?${params}`);
    }
    getCollectionExecutions(collectionId) {
        return this.base.get(`${rt_cg_collections}/${collectionId}/executions`);
    }
    getExecutionComments(executionId) {
        return this.base.get(`${rt_cg_executions}/${executionId}/comments`);
    }
    addExecutionComment(executionId, post) {
        return this.base.post(`${rt_cg_executions}/${executionId}/comments`, post);
    }
    getExecutionRatings(executionId) {
        return this.base.get(`${rt_cg_executions}/${executionId}/ratings`);
    }
    addExecutionRating(executionId, post) {
        return this.base.post(`${rt_cg_executions}/${executionId}/ratings`, post);
    }
    createResult(executionId) {
        return this.base.post(`${rt_cg_executions}/${executionId}/results`);
    }
    getResultById(executionId) {
        return this.base.get(`${rt_cg_executions}/${executionId}`);
    }
    deleteResult(resultId) {
        return this.base.delete(`${rt_cg_results}/${resultId}`);
    }
    getResults(query) {
        const params = createQueryParams(query);
        return this.base.get(`${rt_cg_results}?${params}`);
    }
    getExecutionResults(executionId) {
        return this.base.get(`${rt_cg_executions}/${executionId}/results`);
    }
    getResultComments(resultId) {
        return this.base.get(`${rt_cg_results}/${resultId}/comments`);
    }
    addResultComment(resultId, post) {
        return this.base.post(`${rt_cg_results}/${resultId}/comments`, post);
    }
    getResultRatings(resultId) {
        return this.base.get(`${rt_cg_results}/${resultId}/ratings`);
    }
    addResultRatings(resultId, post) {
        return this.base.post(`${rt_cg_results}/${resultId}/ratings`, post);
    }
    getFineTuningExecution(executionId) {
        return this.base.get(`${rt_ft_executions}/${executionId}`);
    }
    deleteFineTuningExecution(executionId) {
        return this.base.delete(`${rt_ft_executions}/${executionId}`);
    }
    updateFineTuningExecution(executionId, post) {
        return this.base.patch(`${rt_ft_executions}/${executionId}`, post);
    }
    getFineTuningExecutions(query) {
        const params = createQueryParams(query);
        return this.base.get(`${rt_ft_executions}?${params}`);
    }
}
